import React from 'react';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import { compareNumber } from '../../../../helper/uiFunctions';

const BudgetHeaderLocationWiseViewRow = ({ formObject, rowKey }) => {
    const location = formObject.getFormData(rowKey, '', 'location');
    const isUnassigned = !location.val || compareNumber(location.val, 0);

    return (
        <ul className="uiDPEditLine">
            <li className="uiColumnLeft uiColumn100">
                <FormROValue formObject={formObject} rowKey={rowKey} format="#" action={{ paramName: 'docId' }} />
            </li>
            <li className="uiColumnLeft" style={{ width: '185px' }}>
                {isUnassigned ? (
                    <SarasTrans value="None" />
                ) : (
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: 'location' }} />
                )}
            </li>
            <li className="uiColumnLeft uiColumn50">
                <div>
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: 'uom1' }} />
                </div>
                <FormWrapper formObject={formObject} rowKey={rowKey} customWrapper="div" action={{ paramName: 'uom2' }}>
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: 'uom2' }} />
                </FormWrapper>
            </li>
            <li className="uiColumnRight uiColumnQty">
                <div>
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: 'value1' }} />
                </div>
                <FormWrapper formObject={formObject} rowKey={rowKey} customWrapper="div" action={{ paramName: 'value2' }}>
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: 'value2' }} />
                </FormWrapper>
            </li>
            <li className="uiColumnRight uiColumnQty">
                <div>
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: 'linkedValue1' }} />
                </div>
                <FormWrapper formObject={formObject} rowKey={rowKey} customWrapper="div" action={{ paramName: 'linkedValue2' }}>
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: 'linkedValue2' }} />
                </FormWrapper>
            </li>
            <li className="uiColumnLeft" style={{ width: '220px' }}>
                <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: 'comment' }} />
            </li>
        </ul>
    );
};

export default BudgetHeaderLocationWiseViewRow;
